import i18n from '@/utils/i18n';
// import parseTime, formatTime and set to filter
import { parseTime, formatTime, filterCardCode, mobileShowFormatter } from '@/utils';
export { parseTime, formatTime, filterCardCode, mobileShowFormatter };
import moment from 'moment';
/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + 's';
}

export function moneyFilter(money, label) {
  if (!money) {
    if (money === 0) {
      return money;
    }
    return label !== undefined ? label : '--';
  }
  return Number(money).toFixed(2);
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute');
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour');
  } else {
    return pluralize(~~(between / 86400), ' day');
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1e18, symbol: 'E' },
    { value: 1e15, symbol: 'P' },
    { value: 1e12, symbol: 'T' },
    { value: 1e9, symbol: 'G' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'k' },
  ];
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') +
        si[i].symbol
      );
    }
  }
  return num.toString();
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export function parsesToRange(timeStamp) {
  const startDdate = window.formateTimesStamp(timeStamp, 'md');
  const endDate = moment(window.formateTimesStamp(timeStamp)).add(1, 'd').format('MM-DD');
  return startDdate.replace(/-/g, '.') + '-' + endDate.replace(/-/g, '.');
}
export function parsesToRangeHour(timeStamp) {
  const startDdate = window.formateTimesStamp(timeStamp, 'md');

  return startDdate.replace(/-/g, '.');
}
export function filterGuestTypeName(guestTypeName) {
  const nameEnum = {
    fullDay: i18n.t('filtersIndex.all'),
    selfUse: i18n.t('filtersIndex.sinceThe'),
    free: i18n.t('filtersIndex.free'),
    team: i18n.t('filtersIndex.group'),
    protocolCompany: i18n.t('filtersIndex.association'),
    hour: i18n.t('filtersIndex.theClock'),
    nonMember: i18n.t('common.nonmember'),
    member: i18n.t('common.member'),
    longTermFullDay: i18n.t('filtersIndex.long'),
  };
  return nameEnum[guestTypeName] || guestTypeName;
}
export function orderStatusType(type) {
  // 预入住单状态
  const typeEnum = {
    1: i18n.t('filtersIndex.inapplicability'),
    2: i18n.t('filtersIndex.haveProcessed'),
    3: i18n.t('filtersIndex.notProcessed'),
  };
  return typeEnum[type] || type;
}

export function emptyText(text, defaultText) {
  if (text === 'empty') return '';
  if ((text && !!text.toString().trim()) || text + '' === '0') {
    return text;
  } else {
    return defaultText || '--';
  }
}

export function filterPrice(value) {
  if (!value) {
    return 0;
  }
  return parseFloat(value).toFixed(2);
}
// 百分比显示
export function percentage(value) {
  if (!value) {
    return emptyText(value);
  }
  return `${(value * 100).toString().indexOf('.') > 0 ? (value * 100).toFixed(2) : value * 100}%`;
}
// 千分比显示
export function permillage(value) {
  if (!value) {
    return emptyText(value);
  }
  return `${value * 1000}‰`;
}
// 金额的显示 千分位转化
export function moneyMillage(value) {
  if (!value) {
    return '--';
  } else {
    value += '';
    var x = value.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }
}
// 公共过滤为空处理
/**
 *
 * @param {*} val 过滤值
 * @param {*} type 转化的类型，是否是number类型
 */
export function emptyFilter(val, type) {
  if (val === null || val === undefined || val === '') {
    type === 'number' ? (val = '0.00') : (val = '- -');
  }
  return val;
}
export function seeKanEmptyFilter(val) {
  if (val === null || val === undefined || val === '' || val === 0) {
    val === '- -';
  }
  return val;
}
// 数据看板经营概况grid title
export function keyNameFilter(v) {
  switch (v) {
    case 'salePrice':
      v = i18n.t('common.salesAmount');
      break;
    case 'saleAveragePrice':
      v = i18n.t('filtersIndex.averageSalesRate');
      break;
    case 'consumePrice':
      v = i18n.t('common.amountOfConsumption');
      break;
    case 'consumeNight':
      v = i18n.t('filtersIndex.consumptionNight');
      break;
    case 'consumeAveragePrice':
      v = i18n.t('filtersIndex.averageHousePriceOfConsumption');
      break;
    case 'preBook':
      v = i18n.t('filtersIndex.onlinePermeability');
      break;
    case 'cancelNight':
      v = i18n.t('filtersIndex.cancelNight');
      break;
    case 'refuseNight':
      v = i18n.t('filtersIndex.rejectionNight');
      break;
    default:
      v = '--';
  }
  return v;
}
// 订单详情 房单详情 发票
export function receiptProviderFilter(val) {
  switch (val) {
    case 2:
      val = i18n.t('filtersIndex.channelProvision');
      break;
    default:
      val = i18n.t('filtersIndex.theHotelProvides');
  }
  return val;
}
